var _path, _path2, _path3;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgLockAccessV2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.3333 11.1111H9.66666C9.23711 11.1111 8.88889 11.4593 8.88889 11.8889V14.2222C8.88889 14.6518 9.23711 15 9.66666 15H14.3333C14.7629 15 15.1111 14.6518 15.1111 14.2222V11.8889C15.1111 11.4593 14.7629 11.1111 14.3333 11.1111Z",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.4444 11.1111V9.55556C10.4444 9.143 10.6083 8.74733 10.9 8.45561C11.1918 8.16389 11.5874 8 12 8C12.4125 8 12.8082 8.16389 13.0999 8.45561C13.3916 8.74733 13.5555 9.143 13.5555 9.55556V11.1111",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.56747 3.65273C10.7943 2.75938 13.2862 2.78391 15.4948 3.72093C17.7035 4.65794 19.4481 6.4307 20.3448 8.6492C21.2415 10.8677 21.2169 13.3502 20.2764 15.5506C19.3358 17.751 17.5564 19.4891 15.3296 20.3825M15.3296 18V21H18.5M4.76942 6.58324V6.59447M3 10.8948V10.906M3.6424 15.4983V15.5095M6.49376 19.1698V19.1811M10.8215 20.9326V20.9439",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLockAccessV2);
export default __webpack_public_path__ + "static/media/LockAccessV2.755f15a2eb35d18defd61fc5e979ee50.svg";
export { ForwardRef as ReactComponent };